var render, staticRenderFns
import script from "./savings_report.vue?vue&type=script&lang=js&"
export * from "./savings_report.vue?vue&type=script&lang=js&"
import style0 from "./savings_report.vue?vue&type=style&index=0&id=52664b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52664b02",
  null
  
)

export default component.exports